import React, { useEffect, useState } from "react";

export function AdminDimensionalUser({ userData, darkMode }) {
  return (
    <div className="card card-flush mb-6 mb-xl-9" style={{ height: '600px' }}>
      <div className="card-header mt-6">
        <div className="card-title flex-column">
          <h2 className="mb-1">Perfis Dimensionais</h2>
          <div className="fs-6 fw-semibold text-muted">Total 3 perfis</div>
        </div>
      </div>

      {userData.relatorioEnviado == 1 ? (
        <div className="card-body d-flex flex-column">
        <div className="d-flex align-items-center position-relative mb-7">
          <div className="position-absolute top-0 start-0 rounded h-100 bg-secondary w-4px"></div>

          <div className="fw-semibold ms-5">
            <p className="fs-5 fw-bold text-gray-900 text-hover-primary">
              Perfil Cognitivo
            </p>

            <div className="fs-7 text-muted">{userData.cognitivo}</div>
          </div>
        </div>

        <div className="d-flex align-items-center position-relative mb-7">
          <div className="position-absolute top-0 start-0 rounded h-100 bg-secondary w-4px"></div>

          <div className="fw-semibold ms-5">
            <p
              href="#"
              className="fs-5 fw-bold text-gray-900 text-hover-primary"
            >
              Perfil Relacional
            </p>

            <div className="fs-7 text-muted">{userData.relacional}</div>
          </div>
        </div>

        <div className="d-flex align-items-center position-relative mb-7">
          <div className="position-absolute top-0 start-0 rounded h-100 bg-secondary w-4px"></div>

          <div className="fw-semibold ms-5">
            <p
              href="#"
              className="fs-5 fw-bold text-gray-900 text-hover-primary"
            >
              Perfil Socioemocional
            </p>

            <div className="fs-7 text-muted">{userData.socioemocional}</div>
          </div>
        </div>
      </div>
      ) : (
      <div className="card-body d-flex flex-column">
        <p>Usuário não terminou o questionário. Não possui informações suficientes</p>
      </div>
      )}
    </div>
  );
}
